import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { createTeamsCommunicationsSlice } from './actions';
import { TeamsCommunicationsStore } from './types';
import { ZustandStores } from '../../utils';
import { createIndexedDBStorage } from '../../utils/indexedDBAdapter';

export const useTeamsCommunicationsStore = create<TeamsCommunicationsStore>()(
  persist(
    (set, get, store) => ({
      ...createTeamsCommunicationsSlice(set, get, store),
    }),
    {
      name: ZustandStores.TEAMS_COMMUNICATIONS,
      storage: createJSONStorage(() => createIndexedDBStorage()),
    },
  ),
);
